/**
 * 商户结算统计
 */
<template>
  <div class="batch-statistics-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>批次统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 销售-月度毛利折线图 -->
    <el-card class="total-gross-card chart-card" shadow="hover">
      <div slot="header" class="chart-card-header gross-header-with-form">
        <div class="chart-title-left">
          <i class="el-icon-s-finance header-icon"></i>
          <span>月度毛利</span>
        </div>
        <el-form :inline="true" class="total-gross-form" size="small">
          <el-form-item label="月份范围:">
            <el-date-picker
              v-model="grossStartMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份"
              style="width: 120px"
            />
            <span class="range-sep">至</span>
            <el-date-picker
              v-model="grossEndMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份"
              style="width: 120px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="fetchMonthlyGrossChart">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="grossChartLoading" class="chart-body">
        <div ref="grossChartRef" class="chart-single-wrap"></div>
        <div v-if="!grossChartLoading && !grossHasData" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-card>

    <!-- 搜索筛选 -->
    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户类型">
          <el-select
            v-model="formInline.agentType"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.disCompanyName"
            placeholder="请输入服务商名称（支持模糊搜索）"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="电销">
          <el-input
            v-model="formInline.phoneSalesId"
            placeholder="电销销售ID"
            clearable
            class="search-input-id"
          ></el-input>
        </el-form-item>
        <el-form-item label="面销">
          <el-input
            v-model="formInline.faceSalesId"
            placeholder="面销销售ID"
            clearable
            class="search-input-id"
          ></el-input>
        </el-form-item>
        <el-form-item label="返点">
          <el-select
            v-model="formInline.hasRebate"
            placeholder="全部"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="exportdata">导出数据</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="加载中..."
      empty-text="暂无数据"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="batchNumber"
        label="批次号"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.batchNumber)">
            {{ scope.row.batchNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="agentType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ getAgentTypeLabel(scope.row.merchantType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneSalesName" label="电销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faceSalesName" label="面销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="serviceFee" label="服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{
            scope.row.serviceFee ? scope.row.serviceFee.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="managementFee"
        label="管理费"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.managementFee ? scope.row.managementFee.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.managementFeeRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="实际到账"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.amountReceived ? scope.row.amountReceived.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bottomRate" label="底价" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.bottomRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="actualQuotePrice"
        label="实际报价"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.actualQuotePrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.rebate != null &&
                scope.row.rebate !== '' &&
                Number(scope.row.rebate) !== 0
                  ? '#f56c6c'
                  : '#909399',
            }"
          >
            {{ formatRate(scope.row.rebate) || '0.00%' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="managementFeeMode"
        label="管理费承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>

          <span v-else-if="scope.row.managementFeeMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >

          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="commissionRate"
        label="提成比例"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.commissionRate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="实时佣金" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{
            scope.row.commission ? scope.row.commission.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="grossProfit" label="毛利" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{
            scope.row.grossProfit != null ? Number(scope.row.grossProfit).toFixed(2) : '0.00'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="服务商"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.distributeCompanyName)">
            {{ scope.row.distributeCompanyName }}
          </span>
        </template>
      </el-table-column>
    </el-table>
      <div class="summary-panel">
      <el-row :gutter="20">
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span>总服务费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalServiceFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span>总管理费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalManagementFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span>总佣金：</span
              ><span>{{
                formatNumber(currentPageSummary.totalCommission)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6"
          ><div>
            <div class="m-bott-15">
              <span>总毛利：</span
              ><span>{{
                formatNumber(currentPageSummary.totalGrossProfit)
              }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      </div>
      <!-- 分页组件 -->
      <div class="pagination-wrap">
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getSalesSettlementBatch, getSalesMonthlyGrossProfit } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      infos: {
        totalServiceFee: 0,
        totalCommission: 0,
      },
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        phoneSalesId: "",
        faceSalesId: "",
        startDate: "",
        endDate: "",
        agentType: "",
        hasRebate: "",
        date: [],
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      // 月度毛利折线图
      grossStartMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-01`;
      })(),
      grossEndMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`;
      })(),
      monthlyGrossData: [],
      grossChart: null,
      grossChartLoading: false,
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */
  computed: {
    grossHasData() {
      return this.monthlyGrossData && this.monthlyGrossData.length > 0;
    },
    currentPageSummary() {
      const summary = this.listData.reduce(
        (acc, item) => {
          acc.totalServiceFee += Number(item.serviceFee || 0);
          acc.totalManagementFee += Number(item.managementFee || 0);
          acc.totalCommission += Number(item.commission || 0);
          acc.totalGrossProfit += Number(item.grossProfit != null ? item.grossProfit : 0);
          return acc;
        },
        {
          totalServiceFee: 0,
          totalManagementFee: 0,
          totalCommission: 0,
          totalGrossProfit: 0,
        }
      );

      return summary;
    },
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.grossChartRef) {
        this.grossChart = echarts.init(this.$refs.grossChartRef);
        this.fetchMonthlyGrossChart();
      }
    });
    window.addEventListener("resize", this.handleGrossChartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleGrossChartResize);
    if (this.grossChart) {
      this.grossChart.dispose();
      this.grossChart = null;
    }
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        phoneSalesId: "",
        faceSalesId: "",
        agentType: "",
        hasRebate: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        phoneSalesId: formInline.phoneSalesId || undefined,
        faceSalesId: formInline.faceSalesId || undefined,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
        hasRebate: formInline.hasRebate === "" ? undefined : formInline.hasRebate,
      };
      getSalesSettlementBatch(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },
    // 构造月份区间列表（含首尾）
    getMonthRange(startMonth, endMonth) {
      const res = [];
      const [sy, sm] = startMonth.split("-").map(Number);
      const [ey, em] = endMonth.split("-").map(Number);
      let y = sy;
      let m = sm;
      while (y < ey || (y === ey && m <= em)) {
        res.push(`${y}-${String(m).padStart(2, "0")}`);
        m += 1;
        if (m > 12) {
          m = 1;
          y += 1;
        }
      }
      return res;
    },
    // 拉取并渲染月度毛利折线图
    fetchMonthlyGrossChart() {
      const startMonth = this.grossStartMonth;
      const endMonth = this.grossEndMonth;
      if (!startMonth || !endMonth) {
        this.monthlyGrossData = [];
        this.renderGrossChart();
        return;
      }
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning("结束月份不能早于开始月份");
        return;
      }
      if (monthDiff > 24) {
        this.$message.warning("时间范围最大2年（24个月）");
        return;
      }
      this.grossChartLoading = true;
      getSalesMonthlyGrossProfit({ startDate: startMonth, endDate: endMonth })
        .then((res) => {
          if (res && (res.msg === "success" || res.code === 0) && res.data) {
            const items = Array.isArray(res.data) ? res.data : res.data.items || [];
            const map = {};
            items.forEach((d) => {
              const ym = (d.yearMonth || "").toString();
              if (!ym) return;
              const val = Number(d.grossProfit);
              map[ym] = (map[ym] || 0) + (isNaN(val) ? 0 : val);
            });
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.monthlyGrossData = fullMonths.map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              totalGross: map[ym] || 0,
            }));
            this.renderGrossChart();
          } else {
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.monthlyGrossData = fullMonths.map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              totalGross: 0,
            }));
            this.renderGrossChart();
            const msg = (res && (res.msg || res.message)) || "";
            if (msg) this.$message.error(msg);
          }
        })
        .catch((err) => {
          const fullMonths = this.getMonthRange(startMonth, endMonth);
          this.monthlyGrossData = fullMonths.map((ym) => ({
            yearMonth: ym,
            monthLabel: ym.replace("-", "年") + "月",
            totalGross: 0,
          }));
          this.renderGrossChart();
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || "";
          if (msg) this.$message.error(msg);
        })
        .finally(() => {
          this.grossChartLoading = false;
        });
    },
    renderGrossChart() {
      if (!this.grossChart) return;
      const aggregated = this.monthlyGrossData;
      const months = aggregated.map((d) => d.yearMonth);
      const monthLabels = aggregated.map((d) => d.monthLabel);
      const values = aggregated.map((d) => (d.totalGross != null ? Number(d.totalGross) : 0));
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "line" },
          formatter: (params) => {
            if (!params || !params.length) return "";
            const idx = params[0].dataIndex;
            const ym = months[idx] || "";
            const val = aggregated[idx] ? aggregated[idx].totalGross : 0;
            return `${ym}<br/>当月总毛利：${Number(val).toFixed(2)} 元`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: "category",
          data: monthLabels.length ? monthLabels : ["暂无数据"],
          axisLine: { lineStyle: { color: "#e4e7ed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        yAxis: {
          type: "value",
          name: "毛利(元)",
          nameTextStyle: { color: "#606266", fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0", type: "dashed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        series: [
          {
            name: "月度毛利",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: "#67C23A" },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(103, 194, 58, 0.25)" },
                  { offset: 1, color: "rgba(103, 194, 58, 0.02)" },
                ],
              },
            },
          },
        ],
      };
      this.grossChart.setOption(option, true);
      this.$nextTick(() => this.grossChart && this.grossChart.resize());
    },
    handleGrossChartResize() {
      this.grossChart && this.grossChart.resize();
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find(
        (item) => item.value === agentType
      );
      return type ? type.label : "未知";
    },
    exportdata() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }

      // 默认导出99999
      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        phoneSalesId: this.formInline.phoneSalesId || undefined,
        faceSalesId: this.formInline.faceSalesId || undefined,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        hasRebate:
          this.formInline.hasRebate === "" ? undefined : this.formInline.hasRebate,
        export: 1,
      };
      getSalesSettlementBatch(params)
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return ""; // 或者根据你的需求返回其他默认值
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
  },
};
</script>

<style scoped>
.batch-statistics-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.total-gross-card {
  margin-top: 8px;
  margin-bottom: 16px;
}
.chart-card {
  border-radius: 8px;
  overflow: hidden;
}
.chart-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}
.chart-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chart-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chart-card-header .header-icon {
  font-size: 18px;
  color: #409eff;
}
.chart-card >>> .el-card__body {
  padding: 20px;
}
.chart-body {
  min-height: 360px;
  position: relative;
}
.chart-single-wrap {
  width: 100%;
  height: 360px;
}
.chart-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #fafafa;
  border-radius: 6px;
}
.chart-empty i {
  font-size: 40px;
  margin-bottom: 8px;
}
.chart-empty p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}
.total-gross-form {
  margin: 0;
}
.total-gross-form .el-form-item {
  margin-bottom: 0;
}
.range-sep {
  margin: 0 6px;
  color: #606266;
}
.gross-chart-wrap {
  width: 100%;
  height: 320px;
}
.gross-chart-empty {
  text-align: center;
  color: #909399;
  padding: 60px 0;
}

/* 搜索区、表格、按钮 - 与销售主管风格一致 */
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.search-form .search-input-id {
  width: 140px;
}
.toolbar {
  margin: 16px 0;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.summary-panel {
  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}
.summary-panel .m-bott-15 {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}
.pagination-wrap {
  margin-top: 16px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/sales/salesBatchStatistics.vue